import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const HandlerReducer = createSlice({
  name: "Handler",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("HandlerReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = HandlerReducer;
export const { defaultAction } = actions;
export default reducer;
